import { Link } from '@mui/material';

type LandingButtonProps = {
  href: string;
  svg: React.ReactNode;
};

const LandingButton = ({ href, svg }: LandingButtonProps) => {
  const gradientColor1 = '#E9414C';

  return (
    <Link
      href={href}
      underline="none"
      sx={{
        display: 'inline-block',
        cursor: 'pointer',

        '& .landing-button': {
          width: '100%'
        },

        '&:hover': {
          '.button-arrow': {
            fill: gradientColor1
          },

          '.button-gradient-color-2': {
            stopColor: gradientColor1
          }
        }
      }}
    >
      {svg}
    </Link>
  );
};

export default LandingButton;
